<template>
    <div
        v-if="testimonials.length"
        class="md-testimonial layout9 mg-bg"
        :style="{
            ...spaceStyle,
            ...colorStyle,
            'background-color': bgColor
        }"
    >
        <div class="reviews-container">
            <div class="title-wrap f-col">
                <site-title
                    class="review-title"
                    :title="title"
                />
                <div class="swiper-button-wrap" v-if="testimonials?.length > 2 && !isMobileSize">
                    <span class="swiper-button prevbutton">
                        <i class="iconfont icon-arrow_06_left"></i>
                    </span>
                    <span class="swiper-button nextbutton">
                        <i class="iconfont icon-arrow_06_right"></i>
                    </span>
                </div>
            </div>
            <swiper
                v-bind="layout9SwiperOptions"
                :class="{ ['len' + testimonials.length]: !isMobileSize }"
            >
                <slide
                    v-for="
                        (item,
                         index)
                            in
                                testimonials"
                    :key="index"
                    :style="{ background: agentBgColor }"
                >
                    <img v-if="item.rmaTrackPixelUrl" class="rma-pixel-img" :src="item.rmaTrackPixelUrl" loading="lazy" alt="" />
                    <div class="item" @click="toViewMore(item)">
                        <div class="desc" v-html="item.reviewContent"></div>
                        <div class="agent-info">
                            <div class="agent-star-name">
                                <div class="start-box">
                                    <ReviewScore
                                        :onlyShowActiveScore="true"
                                        :sourceType="item.sourceType"
                                        :score="item.reviewRate"
                                        :iconSize="16"
                                        :iconSpace="5"
                                        :iconName="'icon-Star'"
                                    />
                                </div>
                                <div class="agent-name">
                                    <p
                                        class="name"
                                        v-if="item.reviewerName"
                                        v-html="item.reviewerName"
                                    ></p>
                                    <p
                                        class="license"
                                        v-if="item.transactionInfo"
                                        v-html="item.transactionInfo"
                                    ></p>
                                </div>
                            </div>
                            <div class="agent-avatar">
                                <site-img
                                    v-if="item.avatarLink"
                                    class="avatar"
                                    :src="item.avatarLink"
                                    dir="height"
                                />
                                <span class="avatar-icon" v-else>
                                    <i class="iconfont icon-people_02"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                </slide>
            </swiper>
        </div>
        <schema-info :info="seoSchema" v-if="seoSchema" />
    </div>
</template>

<script>
import common from '../index';
import mixinSlide from '../mixin-slide';
export default {
    mixins: [common, mixinSlide],
    data: function() {
        return {
            pcPerView: 2.4
        };
    },
    computed: {
        layout9SwiperOptions({ isMobileSize }) {
            return {
                ...this.options,
                slidesPerView: isMobileSize ? 1.1 : 2.4,
                slidesPerGroup: 1,
                loop: false,
                spaceBetween: 2,
                initialSlide: 0,
                autoHeight: isMobileSize ? true : false,
            };
        }
    }
};
</script>

<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
.md-testimonial.layout9 {
    .rma-pixel-img{
      display: block;
        width: 0;
        height: 0;
    }
    .title-wrap {
        min-height: 50px;
        position: relative;
        margin-bottom: 40px;
        .review-title {
            width: calc(100% - 150px);
        }
        .swiper-button-wrap {
            width: 98px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            color: var(--g-primary-color);
            .swiper-button {
                cursor: pointer;
                &.navigation-disabled {
                    opacity: 0.3;
                    cursor: not-allowed;
                }
                .iconfont {
                    color: var(--g-primary-color);
                }
            }
        }
    }
    .swiper {
        height: 600px;
        .swiper-slide {
            width: 600px;
            height: 100%;
            .item {
                width: 100%;
                height: 100%;
                padding: 50px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                gap: 50px;                cursor: pointer;
            }
            .agent-info {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
                gap: 50px;
                .agent-star-name {
                    width: calc(100% - 50px - 80px);
                    .start-box {
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        align-items: center;
                        .icon-Star {
                            color: var(--g-primary-color);
                        }
                    }
                    .agent-name {
                        margin-top: 20px;
                        .name {
                            color: var(--g-primary-color);
                            font-style: var(--font-medium);
                            font-weight: 500;
                            font-size: 16px;
                            line-height: 1.5;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            white-space: nowrap;
                        }
                        .license {
                            color: var(--g-text-color);
                            font-style: var(--font-normal);
                            font-weight: 400;
                            font-size: 14px;
                            line-height: 1.8;
                        }
                    }
                }
                .agent-avatar {
                    width: 80px;
                    height: 80px;
                    .avatar,
                    .avatar-icon {
                        width: 100%;
                        aspect-ratio: 1;
                        object-fit: cover;
                        border-radius: 50%;
                        vertical-align: middle;
                    }
                    .avatar-icon {
                        text-align: center;
                        line-height: 80px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        border: 2px solid rgba(168, 168, 168, 0.3);
                        .iconfont {
                            color: var(--g-primary-color);
                            font-size: 32px;
                        }
                    }
                }
            }
            .desc {
                height: 300px;
                color: var(--g-primary-color);
                font-style: var(--font-medium);
                font-size: 24px;
                line-height: 1.5;
                overflow-y: auto;
                padding-right: 10px;
                &::-webkit-scrollbar {
                    width: 6px;
                    display: none;
                }
                &:hover::-webkit-scrollbar {
                    display: block;
                }

                &::-webkit-scrollbar-track {
                    background: transparent;
                    border-radius: 6px;
                }
                &::-webkit-scrollbar-thumb {
                    border-radius: 6px;
                    position: relative;
                    display: block;
                    width: 0;
                    height: 0;
                    cursor: pointer;
                    background-color: rgba(218, 218, 218, 1);
                    -webkit-transition: 0.3s background-color;
                    transition: 0.3s background-color;
                }
            }
        }
        &.len1 {
            .swiper-slide {
                width: 100% !important;
            }
        }
        &.len2 {
            .swiper-slide {
                width: calc((100% - 2px) / 2) !important;
            }
        }
    }

    @include media-800 {
       
        .title-wrap {
            margin-bottom: 20px;
            min-height: 30px;
            position: static;
            .review-title {
                width: 100%;
            }
        }
        .swiper {
            height: auto;
            .swiper-slide {
                width: 344px;
                height: auto;
                &:nth-child(1) {
                    margin-left: 15px;
                }
                &:last-child {
                    margin-right: 0 !important;
                }
                .item {
                    padding: 20px 15px;
                    display: block;
                }
                .desc {
                    height: 330px;
                    padding-right: 0;
                    margin-bottom: 20px;
                    // overflow-y: unset;
                    // height: auto;
                    font-size: 18px;
                    overflow-x: auto;
                    &::-webkit-scrollbar {
                        display: block;
                    }
                }
                .agent-info {
                    gap: 20px;
                    .agent-star-name {
                        width: calc(100% - 20px - 50px);
                        .agent-name {
                            .name {
                                font-size: 16px;
                                line-height: 1.5;
                            }
                            .license {
                                font-size: 12px;
                                line-height: 1;
                            }
                        }
                    }
                    .agent-avatar {
                        width: 50px;
                        height: 50px;
                        .avatar-icon {
                            line-height: 50px;
                            border: 1.25px solid rgba(168, 168, 168, 0.3);
                            .iconfont {
                                font-size: 20px;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
